import React from 'react'
import CollabrationHero from './CollabrationHero'
import OurProduct from './OurProduct'
import GolobalWellness from './GolobalWellness'
import JeenaSikho from './JeenaSikho'
import Hydration from './Hydration'
import ChooseMakeWay from './ChooseMakeWay'
import JoinUs from './JoinUs'

const CollabrationPage = () => {
  return (
      <>
          <CollabrationHero />
          <OurProduct />
          <GolobalWellness />
          <JeenaSikho />
          <Hydration />
          <ChooseMakeWay />
          <JoinUs/>
      </>
  )
}

export default CollabrationPage